import { render, staticRenderFns } from "./remises.vue?vue&type=template&id=58045f28&scoped=true&"
import script from "./remises.vue?vue&type=script&lang=js&"
export * from "./remises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58045f28",
  null
  
)

export default component.exports